module.exports = __webpack_public_path__ + "img/bar1Green.2cd87966.svg";